module.exports = __webpack_public_path__ + "static/mobile-sour-cream-onion-07e54dcb84c9d26a2431651ead7378f5.png";